import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalString,
    optionalBoolean,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

const accountingProviderSchema = () =>
    z
        .union([z.enum(['xero', 'quick_books']), z.literal(''), z.null()])
        .optional();

export const createOrganisationAccountingsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        sales_account_code: optionalString(),
        accounting_provider: accountingProviderSchema(),
        accounting_disconnect_message: optionalString(),
        lock_accounting_provider: optionalBoolean(),
        user_email: optionalString(),
    });

export const createOrganisationAccountingsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createOrganisationAccountingsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.organisation_accountings,
    );

export const createOrganisationAccountingsDeleteSchema = () =>
    createDeleteSchema();

export const createOrganisationAccountingsSchemas = () => ({
    add: createOrganisationAccountingsAddSchema(),
    update: createOrganisationAccountingsUpdateSchema(),
    delete: createOrganisationAccountingsDeleteSchema(),
});
